import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Shared layout for legal pages (Terms, Privacy, Cookies, Refund, Legal).
 * Clean, readable, minimal animation — preserves seriousness of legal content.
 */
export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-linx-bg text-linx_text-primary flex flex-col">
      <Navbar />

      <main className="flex-1 pt-28 pb-20">
        <div className="section-container">
          {/* Back link */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-linx_text-muted hover:text-accent-blue transition-colors mb-10"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Retour à l'accueil
          </Link>

          <article className="max-w-3xl mx-auto">
            {/* Title */}
            <h1 className="font-display text-section-title font-bold text-linx_text-primary mb-4">
              {title}
            </h1>

            {lastUpdated && (
              <p className="text-sm text-linx_text-muted mb-10">
                Dernière mise à jour : {lastUpdated}
              </p>
            )}

            {/* Legal content */}
            <div className="legal-content space-y-8 text-linx_text-secondary text-[15px] leading-relaxed">
              {children}
            </div>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}

/**
 * Legal section component — for consistent heading + content blocks.
 */
export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-semibold text-linx_text-primary mb-3">
        {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
